import { module } from 'modujs';
import {Recaptcha} from '../utils/recaptcha';
import { isIOS } from '../utils/is'

const CLASS = {
    IS_SUCCESS: 'is-success',
    IS_LOADING: 'is-loading',
    IS_ERROR: 'is-error'
}

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            change: {
                date: 'change',
                select: 'change',
            },
            submit: 'submit'
        }
    }

    init() {

        this.confirmMessage = this.getData('confirm-message');
        this.errorMessage = this.getData('error-message');
        this.genericError = this.$('feedback')[0].innerHTML;

        this.$dateInputs = this.$('date');
        this.$selects = this.$('select');

        this.$dateInputs.forEach(input => {
            if(isIOS()) input.valueAsDate = new Date()
            else input.classList.add('is-empty')
        });
        this.$selects.forEach(select => {
            select.classList.add('is-empty');
        });
    }

    change(e) {
        e.currentTarget.classList.remove('is-empty');
    }

    /**
     * Set loading state (show loader, fade form, and other UI)
     *
     * @param {none}
     */
    setLoadingState() {
        this.el.classList.add(CLASS.IS_LOADING)
    }

    /**
     * Set confirmation state;
     * Display confirmation message
     *
     * @param {string} | confirmation message
     */
    setConfirmationState(message) {
        this.clearState()

        this.el.classList.add(CLASS.IS_SUCCESS)

        this.updateScroll()
    }

    /**
     * Set error state
     *
     * @param {message} | form error message
     */
    setErrorState(message) {
        this.clearState()
        this.$('feedback')[0].innerHTML = message

        this.el.classList.add(CLASS.IS_ERROR)

        this.updateScroll();
    }

    setFieldError(field, messages) {
        this.clearState()

        if (field) {
            const errorElement = field.closest('.c-form_item').querySelector('.c-form_item_error')
            errorElement.innerHTML = messages[0];
        }

        this.el.classList.add(CLASS.IS_ERROR)

        this.updateScroll();
    }

    /**
     * @param form
     */
    clearFieldErrors(form) {
        form.querySelectorAll('.c-form_item_error').forEach((element) => {element.innerHTML = ''});
    }

    /**
     * Clear all state
     *
     * @param
     */
    clearState() {
        this.$('feedback')[0].innerHTML = ""
        this.el.classList.remove(CLASS.IS_SUCCESS)
        this.el.classList.remove(CLASS.IS_LOADING)
        this.el.classList.remove(CLASS.IS_ERROR)

        this.updateScroll('clear')
    }

    /**
     * In case of use of locomotive-scroll, we need to update page height
     *
     * @param {none}
     */
    updateScroll(status) {
        requestAnimationFrame(() => {
            if (status !== 'clear' || window.innerWidth < 700) {
                this.call('scrollTo', {
                    target: this.el,
                    options: {
                        offset: -100
                    }
                }, 'Scroll');
            }

            this.call('update', null, 'Scroll');
        })
    }

    /**
     * Custom submit
     *
     * @param {e} | event
     * @param skipRecaptcha
     */
    submit(e, skipRecaptcha) {
        e.preventDefault();
        const form = e.target

        this.clearState()
        this.setLoadingState()
        this.clearFieldErrors(form)

        let success = true;
        const formData = new FormData(form)
        let hasError = false;

        let data = {}
        for (let [key, prop] of formData) {
            data[key] = prop
        }

        // Execute the recaptcha if it is enabled in the form.
        if (!skipRecaptcha && form.querySelector('.js-recaptcha-response')) {
            Recaptcha.setInputElement(form.querySelector('.js-recaptcha-response'));
            Recaptcha.execute(() => {
                // Submit the form again, but that time skip the recaptcha step
                //   since we already did it.
                this.submit(e, true);
            }, () => {
                this.setErrorState('Something wrong happened');
            });

            return;
        }

        fetch(form.getAttribute('action'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
        .then(response => {
            if (response.status !== 200) {
                hasError = true
            }
            return response.json()
        })
        .catch(error => {
            this.setErrorState(this.genericError);
            return false;
        })
        .then(response => {
            if (!response) {
                return false;
            }
            if (hasError) {
                if (!Object.keys(response.errors).length) {
                    this.errorMessage = this.genericError;
                }

                for (const [fieldName, messages] of Object.entries(response.errors)) {
                    if (fieldName === '_form_') {
                        this.errorMessage = messages[0];
                    }
                    else {
                        const field = form.querySelector('#form-'+fieldName);
                        this.setFieldError(field, messages);
                    }
                }
                this.setErrorState(this.errorMessage)
            } else {
                this.setConfirmationState(this.confirmMessage)
            }
            // this.resetRecaptcha()
        })
        .finally(() => {
            this.el.classList.remove(CLASS.IS_LOADING)
            this.call('scrollTo', { target: this.el, options: { offset: -50 } }, 'Scroll')
        })
    }
}
